import ReactGA from 'react-gtm-module';

const GTMInitializer = ( {gtmId} ) => {
  ReactGA.initialize({gtmId});

  return null;
};

export default GTMInitializer;
